import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Commission-index-1992f2b7c35e14251-1'),
    routerUrl: '/Commission',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Commission')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Commission-index-1992f2b7c35e14251-2'),
        routerUrl: '/CommissionForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./CommissionForm')),
      },
      //$MORE$
    ],
  },
];
